/**Creating announcements functionality is there in this component */

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./CreateAnnouncement.css";
import { getData } from "../../../../Services/ProfileServices";
import { getbarches, getallBanksByRole, getThemeURL } from "../../../../Services/EndPoints";
import timerIcon from '../../../../Assets/Images/timer.png';
import {
  FiFileText,
  FiX,
  FiUpload,
  FiFile,
  FiFilePlus
} from 'react-icons/fi';
import { postDataWithBody } from "../../../../Services/Services";

const CreateAnnouncement = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [banksList, setBanksList] = useState([]);
  const [filteredBranches, setFilteredBranches] = useState([]);
  const [selectedBankId, setSelectedBankId] = useState("");
  const [speechRate, setSpeechRate] = useState(1);
  const [audioUrl, setAudioUrl] = useState(null);
  const [audioBlob, setAudioBlob] = useState(null);
  const [isConverting, setIsConverting] = useState(false);
  const [audioFileName, setAudioFileName] = useState("speech.wav");

  // Separate state for text file and document file
  const [selectedTextFile, setSelectedTextFile] = useState(null);
  const [selectedDocFile, setSelectedDocFile] = useState(null);
  const [textFileError, setTextFileError] = useState("");
  const [docFileError, setDocFileError] = useState("");
  const [stopConversion, setStopConversion] = useState(false);
  const [mediaRecorderRef, setMediaRecorderRef] = useState(null);

  //Based on the File type icon will be added in this method
  const FileTypeIcon = ({ fileName }) => {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'pdf':
        return <div className="file-icon pdf"><FiFile size={18} /> PDF</div>;
      case 'doc':
      case 'docx':
        return <div className="file-icon doc"><FiFileText size={18} /> DOC</div>;
      case 'txt':
        return <div className="file-icon txt"><FiFileText size={18} /> TXT</div>;
      default:
        return <div className="file-icon default"><FiFilePlus size={18} /> FILE</div>;
    }
  };

  //handling txt file max size to 5MB
  const handleTextFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    // Validate file size (5MB limit)
    if (file.size > 5 * 1024 * 1024) {
      setTextFileError("File size exceeds 5MB limit");
      setSelectedTextFile(null);
      return;
    }

    setTextFileError("");
    setSelectedTextFile(file);
  };

  //handling doc file max size to 5MB
  const handleDocFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file size (5MB limit)
    if (file.size > 5 * 1024 * 1024) {
      setDocFileError("File size exceeds 5MB limit");
      setSelectedDocFile(null);
      return;
    }

    setDocFileError("");
    setSelectedDocFile(file);
    setFormData({ ...formData, document: file });
  };

  //Text file upload handling method
  const handleTxtUpload = () => {
    if (!selectedTextFile || selectedTextFile.type !== "text/plain") return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target.result;
      setFormData(prev => ({ ...prev, script: content }));
    };
    reader.readAsText(selectedTextFile);
  };


  //Remove selected text file handling method
  const removeSelectedTextFile = () => {
    setSelectedTextFile(null);
    setTextFileError("");
    // Reset file input
    const fileInput = document.getElementById('txtFileUpload');
    if (fileInput) fileInput.value = "";
  };

  //Remove selected doc file handling method
  const removeSelectedDocFile = () => {
    setSelectedDocFile(null);
    setFormData({ ...formData, document: null });
    setDocFileError("");
    // Reset file input
    const fileInput = document.getElementById('documentUpload');
    if (fileInput) fileInput.value = "";
  };

  //form data
  const [formData, setFormData] = useState({
    name: "",
    bank: "",
    branch: "",
    category: "",
    fromDateTime: "",
    toDateTime: "",
    speed: "Normal",
    script: "",
    mediaType: "text-to-speech",
    voiceType: "female",
    document: null
  });

  //form validations
  const [validationErrors, setValidationErrors] = useState({
    name: "",
    bank: "",
    branch: "",
    category: "",
    script: "",
    document: "",
    fromDateTime: "",
    toDateTime: ""
  });

  //stic data 
  const categories = ["General", "Emergency", "Promotional", "Service"];

  useEffect(() => {
    getUserProfile();
  }, []);

  const getUserProfile = async () => {
    try {
      const userProfile = await getData(getThemeURL);
      if (userProfile && userProfile.length > 0) {
        fetchBanks(userProfile[0]);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      toast.error("Failed to fetch user profile", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  const createPayload = (profile) => {
    let admin_role = "U"; // default value

    if (profile.role_name === "HO") {
      admin_role = "HO";
    } else if (profile.role_name === "SUPER ADMIN") {
      admin_role = "SA";
    }

    return {
      admin_role: admin_role,
      bank_id: profile.bank_id || null,
      branch_id: profile.branch_id || null
    };
  };

  const fetchBanks = async (profile) => {
    try {
      const payload = createPayload(profile);
      const response = await postDataWithBody(getallBanksByRole, payload, {});
      if (response && Array.isArray(response)) {
        setBanksList(response);
      } else {
        console.error("Invalid banks data format:", response);
        toast.error("Failed to load banks data");
      }
    } catch (error) {
      console.error("Error fetching banks:", error);
      toast.error("Failed to load banks data");
    }
  };

  //Based on the bank selection Branhes will get load
  const fetchBranches = async (bankId) => {
    try {
      const response = await getData(getbarches.replace("ID", bankId));
      if (response && Array.isArray(response)) {
        setFilteredBranches(response);
      } else {
        console.error(`Invalid branches data format for bank ${bankId}:`, response);
        setFilteredBranches([]);
      }
    } catch (error) {
      console.error(`Error fetching branches for bank ${bankId}:`, error);
      setFilteredBranches([]);
    }
  };

  const handleBankChange = (e) => {
    const bankId = e.target.value;
    setSelectedBankId(bankId);
    setFormData({ ...formData, bank: bankId, branch: '' });
    setValidationErrors({ ...validationErrors, bank: "" });

    if (bankId) {
      fetchBranches(bankId);
    } else {
      setFilteredBranches([]);
    }
  };

  const handleBranchChange = (e) => {
    const branchId = e.target.value;
    setFormData({ ...formData, branch: branchId });
    setValidationErrors({ ...validationErrors, branch: "" });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "speed") {
      setFormData({ ...formData, [name]: value });
      // Update speech rate based on speed selection
      const speedRates = { "Slow": 0.8, "Normal": 1, "Fast": 1.2 };
      setSpeechRate(speedRates[value] || 1);
    } else {
      setFormData({ ...formData, [name]: value });
    }

    // Clear validation error when user types
    if (validationErrors[name]) {
      setValidationErrors({ ...validationErrors, [name]: "" });
    }
  };

  //converting given text or file to speach
  const convertTextToSpeech = async () => {
    if (!formData.script) {
      toast.error("Please provide text to convert", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      return;
    }

    setIsConverting(true);
    setStopConversion(false);

    try {
      if ('speechSynthesis' in window) {
        // Cancel any ongoing speech
        window.speechSynthesis.cancel();

        const audioContext = new AudioContext();
        const mediaStreamDestination = audioContext.createMediaStreamDestination();
        const mediaRecorder = new MediaRecorder(mediaStreamDestination.stream);
        setMediaRecorderRef(mediaRecorder); // Store media recorder reference

        const audioChunks = [];

        mediaRecorder.ondataavailable = (event) => {
          if (!stopConversion) {
            audioChunks.push(event.data);
          }
        };

        mediaRecorder.onstop = () => {
          if (stopConversion) {
            setIsConverting(false);
            return;
          }

          const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });
          const audioUrl = URL.createObjectURL(audioBlob);

          setAudioBlob(audioBlob);
          setAudioUrl(audioUrl);
          setAudioFileName(`speech_${Date.now()}.wav`);
          setIsConverting(false);

          toast.success("Text converted to speech successfully!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
        };

        mediaRecorder.start();

        const utterance = new SpeechSynthesisUtterance(formData.script);

        // Load voices
        let voices = window.speechSynthesis.getVoices();
        if (voices.length === 0) {
          await new Promise(resolve => {
            window.speechSynthesis.onvoiceschanged = resolve;
            setTimeout(resolve, 1000);
          });
          voices = window.speechSynthesis.getVoices();
        }

        // Improved voice selection
        const voiceGender = formData.voiceType === "female" ? "female" : "male";
        const preferredVoice = voices.find(voice => {
          const voiceName = voice.name.toLowerCase();
          return (
            (voiceGender === "female" &&
              (voiceName.includes("female") ||
                voiceName.includes("woman") ||
                voiceName.includes("woman"))) ||
            (voiceGender === "male" &&
              (voiceName.includes("male") ||
                voiceName.includes("man") ||
                voiceName.includes("guy")))
          );
        }) || voices[0];

        utterance.voice = preferredVoice;
        utterance.rate = speechRate;

        // Calculate duration
        const wordCount = formData.script.split(/\s+/).length;
        const wordsPerMinute = speechRate * 150;
        const durationMinutes = wordCount / wordsPerMinute;
        const durationSeconds = durationMinutes * 60;

        // Update timer
        const timerElement = document.querySelector('.time-display');
        if (timerElement) {
          timerElement.textContent = Math.ceil(durationMinutes);
        }

        // Add stop button functionality
        utterance.onend = () => {
          if (!stopConversion) {
            mediaRecorder.stop();
          }
        };

        window.speechSynthesis.speak(utterance);

        setTimeout(() => {
          if (!stopConversion && mediaRecorder.state !== 'inactive') {
            mediaRecorder.stop();
          }
        }, (durationSeconds * 1000) + 1000);
      } else {
        toast.error("Speech synthesis not supported in this browser", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        setIsConverting(false);
      }
    } catch (error) {
      console.error("Conversion error:", error);
      toast.error("Failed to convert text to speech", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      setIsConverting(false);
    }
  };

  // Cleaning up speech convertion when component unmounts
  useEffect(() => {
    return () => {
      // Clean up speech synthesis when component unmounts
      if ('speechSynthesis' in window) {
        window.speechSynthesis.cancel();
      }
      // Clean up media recorder if exists
      if (mediaRecorderRef && mediaRecorderRef.state !== 'inactive') {
        mediaRecorderRef.stop();
      }
    };
  }, [mediaRecorderRef]);

  //To handle stop text to speech convertion when clicks on Stop button
  const handleStopConversion = () => {
    setStopConversion(true);
    setIsConverting(false);

    if ('speechSynthesis' in window) {
      window.speechSynthesis.cancel();
    }

    if (mediaRecorderRef && mediaRecorderRef.state !== 'inactive') {
      mediaRecorderRef.stop();
    }

    toast.info("Conversion stopped", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000,
    });
  };

  //form validations while submitting
  const validateForm = () => {
    const errors = {
      name: !formData.name ? "Name is required" : "",
      bank: !formData.bank ? "Bank is required" : "",
      branch: !formData.branch ? "Branch is required" : "",
      category: !formData.category ? "Category is required" : "",
      fromDateTime: !formData.fromDateTime ? "Start time is required" : "",
      toDateTime: !formData.toDateTime ? "End time is required" : "",
      script: formData.mediaType === "text-to-speech" && !formData.script ? "Script is required" : "",
      document: formData.mediaType === "document" && !formData.document ? "Document is required" : ""
    };

    setValidationErrors(errors);
    return !Object.values(errors).some(error => error !== "");
  };

  //Creating announcement
  const handleSubmit = async () => {
    if (!validateForm()) {
      toast.error("Please fill all mandatory fields correctly", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      return;
    }

    setIsSubmitting(true);

    try {
      // Create FormData for submission
      const submissionData = new FormData();

      // Add all form fields
      Object.keys(formData).forEach(key => {
        if (key === 'document' && formData[key]) {
          submissionData.append(key, formData[key]);
        } else if (key !== 'document') {
          submissionData.append(key, formData[key]);
        }
      });

      // Add the generated audio if available
      if (audioBlob && formData.mediaType === "text-to-speech") {
        submissionData.append('audio', audioBlob, audioFileName);
      }

      console.log("Form submitted with data:", formData);

      // In a real app, you would send submissionData to your server
      await new Promise(resolve => setTimeout(resolve, 1000));

      toast.success("Announcement created successfully!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });

      navigate(-1);
    } catch (error) {
      console.error("Submission error:", error);
      toast.error("Failed to create announcement", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="main-container mt-4">
        <div className="row">
          {/* First Column - Name, Bank, Branch, Category, Date/Time Pickers */}
          <div className="col-md-6">
            {/* Name */}
            <div className="row mb-3">
              <div className="col-md-12">
                <label htmlFor="name" className="form-label">
                  Name<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${validationErrors.name ? "is-invalid" : ""}`}
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                />
                {validationErrors.name && (
                  <div className="invalid-feedback">
                    {validationErrors.name}
                  </div>
                )}
              </div>
            </div>

            {/* Bank dropdown */}
            <div className="row mb-3">
              <div className="col-md-12">
                <label htmlFor="bank" className="form-label">
                  Bank<span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select ${validationErrors.bank ? "is-invalid" : ""}`}
                  id="bank"
                  name="bank"
                  value={formData.bank}
                  onChange={handleBankChange}
                >
                  <option value="">Select Bank</option>
                  {banksList.map(bank => (
                    <option key={bank.id} value={bank.id}>{bank.bankName}</option>
                  ))}
                </select>
                {validationErrors.bank && (
                  <div className="invalid-feedback">
                    {validationErrors.bank}
                  </div>
                )}
              </div>
            </div>

            {/* Branch dropdown */}
            <div className="row mb-3">
              <div className="col-md-12">
                <label htmlFor="branch" className="form-label">
                  Branch<span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select ${validationErrors.branch ? "is-invalid" : ""}`}
                  id="branch"
                  name="branch"
                  value={formData.branch}
                  onChange={handleBranchChange}
                >
                  <option value="">Select Branch</option>
                  {filteredBranches.map(branch => (
                    <option key={branch.id} value={branch.id}>{branch.branchName}</option>
                  ))}
                </select>
                {validationErrors.branch && (
                  <div className="invalid-feedback">
                    {validationErrors.branch}
                  </div>
                )}
              </div>
            </div>

            {/* Category */}
            <div className="row mb-3">
              <div className="col-md-12">
                <label htmlFor="category" className="form-label">
                  Category<span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select ${validationErrors.category ? "is-invalid" : ""}`}
                  id="category"
                  name="category"
                  value={formData.category}
                  onChange={handleInputChange}
                >
                  <option value="">Select Category</option>
                  {categories.map(category => (
                    <option key={category} value={category}>{category}</option>
                  ))}
                </select>
                {validationErrors.category && (
                  <div className="invalid-feedback">
                    {validationErrors.category}
                  </div>
                )}
              </div>
            </div>

            {/* Date and Time Pickers */}
            <div className="row mb-3">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-6 mb-2">
                    <label htmlFor="fromDateTime" className="form-label">
                      From<span className="text-danger">*</span>
                    </label>
                    <input
                      type="datetime-local"
                      className={`form-control ${validationErrors.fromDateTime ? "is-invalid" : ""}`}
                      id="fromDateTime"
                      name="fromDateTime"
                      value={formData.fromDateTime}
                      onChange={handleInputChange}
                    />
                    {validationErrors.fromDateTime && (
                      <div className="invalid-feedback">
                        {validationErrors.fromDateTime}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6 mb-2">
                    <label htmlFor="toDateTime" className="form-label">
                      To<span className="text-danger">*</span>
                    </label>
                    <input
                      type="datetime-local"
                      className={`form-control ${validationErrors.toDateTime ? "is-invalid" : ""}`}
                      id="toDateTime"
                      name="toDateTime"
                      value={formData.toDateTime}
                      onChange={handleInputChange}
                    />
                    {validationErrors.toDateTime && (
                      <div className="invalid-feedback">
                        {validationErrors.toDateTime}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Second Column - Media selection and associated fields */}
          <div className="col-md-6">
            {/* Media Selection */}
            <div className="row mb-3">
              <div className="col-md-12">
                <label className="form-label">
                  Media<span className="text-danger">*</span>
                </label>
                <div className="d-flex flex-wrap gap-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="mediaType"
                      id="textToSpeech"
                      value="text-to-speech"
                      checked={formData.mediaType === "text-to-speech"}
                      onChange={handleInputChange}
                    />
                    <label className="form-check-label" htmlFor="textToSpeech">
                      Audio
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="mediaType"
                      id="document"
                      value="document"
                      checked={formData.mediaType === "document"}
                      onChange={handleInputChange}
                    />
                    <label className="form-check-label" htmlFor="document">
                      Document
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {/* Text to Speech Configuration */}
            {formData.mediaType === "text-to-speech" && (
              <div className="card mt-2 tts-card">
                <div className="card-body tts-card-body"
                  style={{
                    backgroundColor: 'blue',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    padding: '15px',
                    minHeight: '320px',
                    backgroundRepeat: 'no-repeat',
                    color: 'white'
                  }}
                >
                  {/* Card heading */}
                  <h5 className="mb-3" style={{ color: '#888888' }}>Text to Speech</h5>

                  {/* Voice Selection and Timer in same row */}
                  <div className="mb-3 d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      {/* <div className="form-check me-4">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="voiceType"
                          id="maleVoice"
                          value="male"
                          checked={formData.voiceType === "male"}
                          onChange={handleInputChange}
                        />
                        <label className="form-check-label" htmlFor="maleVoice">
                          Male
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="voiceType"
                          id="femaleVoice"
                          value="female"
                          checked={formData.voiceType === "female"}
                          onChange={handleInputChange}
                        />
                        <label className="form-check-label" htmlFor="femaleVoice">
                          Female
                        </label>
                      </div> */}
                    </div>

                    {/* Timer section */}
                    <div style={{
                      background: 'linear-gradient(to right, #2193B0, #6DD5ED)',
                      borderRadius: '19px',
                      padding: '4px 12px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      height: '40px'
                    }}>
                      {/* Timer icon */}
                      <img
                        src={timerIcon}
                        alt="Timer"
                        style={{
                          width: '18px',
                          height: '18px',
                          flexShrink: 0
                        }}
                      />

                      {/* "Time" label */}
                      <span style={{
                        color: 'black',
                        fontSize: '0.7rem',
                        fontWeight: '500',
                        whiteSpace: 'nowrap',
                        marginTop: '3px'
                      }}>
                        Time
                      </span>

                      {/* Time circle with "min" label */}
                      <div style={{
                        position: 'relative',
                        width: '30px',
                        height: '30px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        {/* White circle */}
                        <div style={{
                          backgroundColor: 'white',
                          borderRadius: '50%',
                          width: '100%',
                          height: '100%',
                          position: 'absolute',
                          top: 0,
                          left: 0
                        }}></div>

                        {/* Time and min label container */}
                        <div style={{
                          position: 'relative',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          zIndex: 1
                        }}>
                          {/* Time number */}
                          <span className="time-display" style={{
                            color: 'black',
                            fontWeight: 'bold',
                            fontSize: '0.8rem',
                            lineHeight: '1'
                          }}>
                            0
                          </span>

                          {/* "min" label */}
                          <span style={{
                            color: 'black',
                            fontSize: '0.5rem',
                            fontWeight: '500',
                            lineHeight: '1',
                            marginTop: '-2px'
                          }}>
                            min
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Text file upload section */}
                  <div className="d-flex mb-1">
                    <div className="input-group" style={{ position: 'relative' }}>
                      <input
                        type="file"
                        className="form-control d-none"
                        id="txtFileUpload"
                        accept=".txt"
                        onChange={handleTextFileChange}
                      />
                      <input
                        style={{
                          borderRadius: '8px 0 0 8px',
                          paddingRight: selectedTextFile ? '30px' : '12px'
                        }}
                        type="text"
                        className="form-control"
                        placeholder="Choose TXT file(Max: 5MB)"
                        readOnly
                        value={selectedTextFile?.name || ""}
                        onClick={() => document.getElementById('txtFileUpload').click()}
                      />
                      {selectedTextFile && (
                        <button
                          className="btn btn-link p-0"
                          onClick={removeSelectedTextFile}
                          style={{
                            position: 'absolute',
                            right: '100px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            zIndex: 5,
                            border: 'none',
                            background: 'transparent'
                          }}
                        >
                          <FiX size={16} style={{ color: 'red' }} />
                        </button>
                      )}
                      <button
                        className="btn"
                        style={{
                          backgroundColor: '#868686',
                          color: 'white',
                          borderRadius: '0 8px 8px 0'
                        }}
                        type="button"
                        onClick={() => document.getElementById('txtFileUpload').click()}
                      >
                        Browse
                      </button>
                    </div>
                    <button
                      className="btn"
                      style={{
                        backgroundColor: '#1a7a73',
                        color: 'white',
                        marginLeft: '5px',
                        borderRadius: '8px'
                      }}
                      type="button"
                      onClick={handleTxtUpload}
                      disabled={!selectedTextFile || selectedTextFile.type !== "text/plain"}
                    >
                      Upload
                    </button>
                  </div>

                  {/* File error display */}
                  {textFileError && <div className="text-danger small">{textFileError}</div>}
                  {selectedTextFile && (
                    <div className="small text-white mt-1">
                      Size: {(selectedTextFile.size / 1024).toFixed(2)} KB
                    </div>
                  )}

                  {/* OR separator */}
                  <div className="text-center mb-3" style={{ color: 'black', fontSize: '15px', marginTop: '10px' }}>or</div>

                  {/* Script textarea */}
                  <div className="mb-3">
                    <textarea
                      className={`form-control ${validationErrors.script ? "is-invalid" : ""}`}
                      id="script"
                      name="script"
                      rows="4"
                      value={formData.script}
                      onChange={handleInputChange}
                      placeholder="Paste the script or type here"
                    />
                    {validationErrors.script && (
                      <div className="invalid-feedback">
                        {validationErrors.script}
                      </div>
                    )}
                  </div>

                  {/* Convert button */}
                  <div className="d-flex justify-content-center flex-column align-items-center">
                    {isConverting ? (
                      <button
                        className="btn px-4 mb-3"
                        style={{ backgroundColor: '#ff4d4f', color: 'white' }}
                        onClick={handleStopConversion}
                      >
                        Stop Conversion
                      </button>
                    ) : (
                      <button
                        className="btn px-4 mb-3"
                        style={{ backgroundColor: '#1a7a73', color: 'white' }}
                        onClick={convertTextToSpeech}
                        disabled={!formData.script}
                      >
                        Convert
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* Document Upload Section */}
            {formData.mediaType === "document" && (
              <div className="row mb-3">
                <div className="col-md-12">
                  <div className="document-upload-container p-3 border rounded" style={{
                    borderStyle: 'dashed',
                    backgroundColor: '#f8f9fa'
                  }}>
                    <label htmlFor="documentUpload" className="form-label d-flex justify-content-between">
                      <span>Upload Document<span className="text-danger">*</span></span>
                    </label>

                    <div className="upload-area text-center p-4 mb-3" style={{
                      border: '1px dashed #ced4da',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      backgroundColor: 'white'
                    }} onClick={() => document.getElementById('documentUpload').click()}>
                      <FiUpload size={36} className="mb-2 text-primary" />
                      <p className="mb-1">Drag & drop your file here or click to browse</p>
                      <p className="small text-muted mb-0">Accepted formats: PDF, DOC, DOCX, TXT (Max: 5MB)</p>

                      <input
                        type="file"
                        className="d-none"
                        id="documentUpload"
                        name="document"
                        onChange={handleDocFileChange}
                        accept=".pdf,.doc,.docx,.txt"
                      />
                    </div>

                    {validationErrors.document && (
                      <div className="text-danger small mb-2">
                        {validationErrors.document}
                      </div>
                    )}
                    {docFileError && <div className="text-danger small mb-2">{docFileError}</div>}

                    {/* Display selected file with icon */}
                    {selectedDocFile && (
                      <div className="selected-file p-3 bg-light rounded d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <FileTypeIcon fileName={selectedDocFile.name} />
                          <div className="ms-2">
                            <div>{selectedDocFile.name}</div>
                            <small className="text-muted">{(selectedDocFile.size / 1024).toFixed(2)} KB</small>
                          </div>
                        </div>
                        <button
                          className="btn btn-sm btn-light rounded-circle"
                          onClick={removeSelectedDocFile}
                          title="Remove file"
                        >
                          <FiX size={16} style={{ color: 'red' }} />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Submit Button */}
      <div className="d-flex justify-content-center mt-3">
        <button
          className="btn btn-success"
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Publishing..." : "Publish"}
        </button>
      </div>

      <ToastContainer />

      {/* Add these styles to your CSS file */}
      <style jsx>{`
      .file-icon {
        display: inline-flex;
        align-items: center;
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 0.8rem;
        font-weight: 500;
      }
      
      .file-icon.pdf {
        background-color: #f8d7da;
        color: #721c24;
      }
      
      .file-icon.doc {
        background-color: #cce5ff;
        color: #004085;
      }
      
      .file-icon.txt {
        background-color: #d4edda;
        color: #155724;
      }
      
      .file-icon.default {
        background-color: #e2e3e5;
        color: #383d41;
      }
      
      .file-upload-container,
      .document-upload-container {
        transition: all 0.3s ease;
      }
      
      .file-upload-container:hover,
      .document-upload-container:hover {
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
      }
      
      .upload-area:hover {
        background-color: #f8f9fa !important;
      }
      
      .selected-file {
        transition: all 0.2s ease;
      }
      
      .selected-file:hover {
        background-color: #e9ecef !important;
      }
    `}</style>
    </>
  );
};

export default CreateAnnouncement;